import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=039c4c31&"
var script = {}
import style0 from "./LoadingCard.vue?vue&type=style&index=0&id=039c4c31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports